import { Rate } from "../rate-type";
import { RateLocationMapper } from "./rate-location.mapper";
import { RateLocation } from "./rate-location.type";
import { Location } from "../../location/location.model";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { countryCodes } from "../../shared/countries/country-codes.const";

export class RateLocationBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected location: Location,
    protected comment: string,
    protected rate: Rate,
    protected parent: RateLocation,
    protected excludedOriginLocations: RateLocation[],
    protected excludedDestinationLocations: RateLocation[],
  ) {}

  public setId(param: number) {
    this.id = param;
  }
  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public get self(): RateLocationBase {
    return this;
  }

  public get countryName() {
    return this.location ? countryCodes[this.location.getCountry()] : null;
  }

  public getLocation(): Location {
    return this.location;
  }

  public setLocation(location: Location): void {
    this.location = location;
  }

  public getComment(): string {
    return this.comment;
  }

  public setComment(comment: string): void {
    this.comment = comment;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getParent(): RateLocation {
    return this.parent;
  }
  public getParentId(): number {
    return this.parent && this.parent.getId() ? this.parent.getId() : null;
  }

  public getExcludedOriginLocations(): RateLocation[] {
    return this.excludedOriginLocations;
  }

  public getExcludedDestinationLocations(): RateLocation[] {
    return this.excludedDestinationLocations;
  }

  public addExcludedDestinationLocation(
    excludedDestinationLocation: RateLocation,
  ): void {
    this.excludedDestinationLocations.push(excludedDestinationLocation);
  }

  public addExcludedOriginLocation(excludedOriginLocation: RateLocation): void {
    this.excludedOriginLocations.push(excludedOriginLocation);
  }

  public clearExcludedDestinationLocations(): void {
    this.excludedDestinationLocations = [];
  }

  public clearExcludedOriginLocations(): void {
    this.excludedOriginLocations = [];
  }

  public removeExcludedDestinationLocation(
    excludedDestinationLocation: RateLocation,
  ): void {
    this.excludedDestinationLocations =
      this.excludedDestinationLocations.filter((obj) => {
        if (obj && excludedDestinationLocation) {
          return obj.getId() !== excludedDestinationLocation.getId();
        }
      });
  }

  public removeExcludedOriginLocation(
    excludedOriginLocation: RateLocation,
  ): void {
    this.excludedOriginLocations = this.excludedOriginLocations.filter(
      (obj) => {
        if (obj && excludedOriginLocation) {
          return obj.getId() !== excludedOriginLocation.getId();
        }
      },
    );
  }

  public isValid() {
    return this.location ? true : false;
  }

  public getClone(): RateLocation {
    return RateLocationMapper.map({
      id: this.getId(),
      discriminator: this.getDiscriminator(),
      location: LocationMapper.map(this.getLocation()),
      comment: this.getComment(),
      rate: RateMapper.map(this.getRate()),
      parent: this.getParent(),
      excludedOriginLocations: this.getExcludedOriginLocations(),
      excludedDestinationLocations: this.getExcludedDestinationLocations(),
    });
  }
}
